module.exports = __webpack_public_path__ + "static/CircularPro-Black.37c0e0b3.woff2";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-Black.woff2
// module id = 714
// module chunks = 168707334958949